import { render, staticRenderFns } from "./WxLogin.vue?vue&type=template&id=01393590&scoped=true"
import script from "./WxLogin.vue?vue&type=script&lang=js"
export * from "./WxLogin.vue?vue&type=script&lang=js"
import style0 from "./WxLogin.vue?vue&type=style&index=0&id=01393590&prod&lang=css"
import style1 from "./WxLogin.vue?vue&type=style&index=1&id=01393590&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01393590",
  null
  
)

export default component.exports